module.exports = __webpack_public_path__ + "static/img/video-bak.a350c03b.gif";